module.exports = __webpack_public_path__ + "img/Big Road.22e66e16.png";